(() => {
    const $parentSubMenuWraps = document.querySelectorAll('.site-menu-bar > .site-menu > .menu-item-has-children');
    const $subMenuWraps = document.querySelectorAll('.site-menu-bar > .site-menu > .menu-item-has-children, .site-menu-bar .menu-item-has-children:not(.menu-item--layout-sub-menu-columns) .menu-item-has-children');

    const enableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        if ($subMenuWrap.classList.contains('menu-item--active')) return;

        $subMenuWrap.classList.add('menu-item--active');
        $subMenuToggle.setAttribute('aria-expanded', 'true');
    };

    const disableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        $subMenuWrap.classList.remove('menu-item--active');
        $subMenuToggle.setAttribute('aria-expanded', 'false');
    };

    const initSubMenuDropdowns = () => {
        $subMenuWraps.forEach($subMenuWrap => {
            if (!$subMenuWrap) return;

            const $subMenuToggle = $subMenuWrap.querySelector('a');

            if (!$subMenuToggle) return;

            $subMenuToggle.addEventListener('click', e => {
                e.preventDefault();
                
                if ($subMenuWrap.classList.contains('menu-item--active')) {
                    disableSubMenu($subMenuWrap, $subMenuToggle);

                    const $activeChildSubMenus = $subMenuWrap.querySelectorAll('.menu-item--active');

                    $activeChildSubMenus?.forEach($activeChildSubMenu => {
                        disableSubMenu($activeChildSubMenu, $activeChildSubMenu.querySelector('a'));
                    });
                } else {
                    enableSubMenu($subMenuWrap, $subMenuToggle);

                    resizeSubMenus();
                }
            });
        });

        $parentSubMenuWraps.forEach($parentSubMenuWrap => {
            const $subMenuToggle = $parentSubMenuWrap.querySelector('a');

            window.addEventListener('click', e => {
                if ($parentSubMenuWrap.contains(e.target)) return;

                disableSubMenu($parentSubMenuWrap, $subMenuToggle);

                const $activeChildSubMenus = $parentSubMenuWrap.querySelectorAll('.menu-item--active');

                $activeChildSubMenus?.forEach($activeChildSubMenu => {
                    disableSubMenu($activeChildSubMenu, $activeChildSubMenu.querySelector('a'));
                });

                setTimeout(() => {
                    resizeSubMenus();
                }, 300);
            });
        });
    };

    const subMenuOffset = () => {
        $subMenuWraps.forEach($subMenuWrap => {
            if (!$subMenuWrap) return;

            const $subMenuDropdowns = $subMenuWrap.querySelectorAll('.sub-menu-dropdown');

            if (!$subMenuDropdowns) return;

            $subMenuDropdowns.forEach($subMenuDropdown => {
                $subMenuDropdown.style.marginLeft = '';

                const leftOffset = $subMenuDropdown.getBoundingClientRect().left;
                const rightOffset = leftOffset + $subMenuDropdown.clientWidth - document.body.clientWidth;

                if (rightOffset > 0) {
                    $subMenuDropdown.style.marginLeft = `${-rightOffset}px`;
                }

                if (leftOffset < 0) {
                    $subMenuDropdown.style.marginLeft = `${-leftOffset}px`;
                }
            });
        });
    };

    const resizeSubMenu = $subMenu => {
        if (!$subMenu) return;

        const $subMenuDropdown = $subMenu.querySelector('.sub-menu-dropdown');
        const $subMenuDropdownInner = $subMenu.querySelector('.sub-menu-dropdown__inner');
        const $subMenuChildren = $subMenu.querySelectorAll('.menu-item--active > .sub-menu');

        let width = $subMenuDropdownInner.clientWidth;
        let height = $subMenuDropdownInner.clientHeight;

        $subMenuChildren?.forEach($subMenuChild => {
            width += $subMenuChild.clientWidth;

            if ($subMenuChild.clientHeight > height) {
                height = $subMenuChild.clientHeight;
            }
        });

        $subMenuDropdown.style.width = `${width}px`;
        $subMenuDropdown.style.height = `${height}px`;
    };

    const resizeSubMenus = () => {
        if (!$parentSubMenuWraps) return;

        $parentSubMenuWraps.forEach($parentSubMenuWrap => {
            resizeSubMenu($parentSubMenuWrap);
        });
    };

    window.addEventListener('resize', () => {
        subMenuOffset();
        resizeSubMenus();
    });

    initSubMenuDropdowns();
    subMenuOffset();
    resizeSubMenus();
})();
